import {Component, OnInit, ViewChild} from '@angular/core';
import {CategoriesService} from '../../api/categories.service';
import {FilterStorageService} from '../../services/filter-storage.service';
import {CategoryModel} from '../../api/category-model';
import {MainCategoryModel} from '../../api/main-category-model';
import {ProgressService} from '../../controls/progress.service';
import {CategoryViewModel} from '../category-view-model';
import {ListViewComponent, SelectEventArgs} from '@syncfusion/ej2-angular-lists';
import {ToastComponent} from '@syncfusion/ej2-angular-notifications';

@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent implements OnInit {

  private categoriesService: CategoriesService;
  private categories: CategoryModel[];
  private mainCategories: MainCategoryModel[];

  public allItems: CategoryViewModel[] = [];
  public filteredItems: CategoryViewModel[] = [];

  public fields: object = {
    groupBy: 'brandName',
    tooltip: 'text',
    text: 'text',
    isChecked: 'active',
    enabled: 'enabled',
    sortBy: 'brandName asc' };

  @ViewChild('listView', {static: true}) listView: ListViewComponent;
  @ViewChild('toast', {static: true}) toast: ToastComponent;
  public position = { X: 'Right' };
  textFilter: string;
  showActiveOnly = false;

  constructor(categoriesService: CategoriesService,
              private filters: FilterStorageService,
              private progress: ProgressService) {
    this.categoriesService = categoriesService;
  }

  async ngOnInit() {
    await this.reloadList();
  }

  private initializeItems() {
    this.allItems = [];
    this.filteredItems = [];

    function buildVm(mc: MainCategoryModel): CategoryViewModel {
      return {
        id: mc.id,
        text: mc.name,
        brandName: mc.brandName,
        active: false
      };
    }

    const allItems = this.mainCategories
      .filter(mc => mc.state === 'A')
      .map(mc => buildVm(mc));

    this.updateActiveState(allItems);

    this.allItems = allItems.sort((v1, v2) => (v1.brandName + v1.text) > (v2.brandName + v2.text) ? 1 : -1);

    this.filteredItems = this.allItems;
  }

  private updateActiveState(list: CategoryViewModel[]) {
    const activeMainCategoryIds = new Set<string>(this.categories
      .filter(c => c.state === 'A')
      .map(c => c.baseID));

    for(const mc of list) {
      mc.active = activeMainCategoryIds.has(mc.id);
    }
  }

  async reloadList() {
    this.progress.show();

    try {
      const categoriesP = this.categoriesService.get(this.filters.getSelectedOrganization().id).toPromise();
      const mainCategoriesP = this.categoriesService.getMain().toPromise();

      const results = await Promise.all([categoriesP, mainCategoriesP]);

      this.categories = results[0].data;
      this.mainCategories = results[1].data;

      if (results[0].total > results[0].data.length) {
        throw new Error('Load all categories');
      }

      if (results[1].total > results[1].data.length) {
        throw new Error('Load all main categories');
      }

      this.initializeItems();
    } finally {
      this.progress.hide();
    }
  }

  async onSelectItem($event: SelectEventArgs) {
    const typedData: any = $event.data;
    const mc: CategoryViewModel = typedData;
    const isChecked = $event.isChecked;

    this.listView.disableItem($event.item);

    try {
      if (isChecked) {
        await this.activate(mc);
      } else {
        await this.deactivate(mc);
      }
    } finally {
      this.listView.enableItem($event.item);
    }
  }

  private async activate(mainCategory: CategoryViewModel) {
    const vm = this.allItems.filter(x => x.id === mainCategory.id)[0];
    try {
      this.showToast('In progress', `Activating - ${mainCategory.text}`);

      const result = await this.categoriesService.activate(
        this.filters.getSelectedOrganization().id,
        {mainCategoryId: mainCategory.id}
      ).toPromise();

      this.showToast('Done', `Activated - ${result.name}`);

      if (this.categories.filter(c => c.baseID === result.baseID)) {
        return ;
      }

      this.categories.push(result);
      vm.active = true;
    } catch (e) {
      this.showToast('Error', `Activating - ${mainCategory.text}. Error - ${e.error.message}`);
    }
  }

  private showToast(title: string, message: string) {
    this.toast.show({
      timeOut: 5000,
      showCloseButton: true,
      title,
      content: message
    });
  }

  private async deactivate(mainCategory: CategoryViewModel) {
    const vm = this.allItems.filter(x => x.id === mainCategory.id)[0];
    this.showToast('In progress', `Deactivating - ${mainCategory.text}`);

    try {
      const category = this.categories.filter(c => c.baseID === mainCategory.id)[0];

      await this.categoriesService.deactivate(
        this.filters.getSelectedOrganization().id,
        category.id
      ).toPromise();
      this.showToast('Done', `Deactivated - ${category.name}`);
      vm.active = false;
    } catch (e) {
      this.showToast('Error', `Deactivating - ${mainCategory.text}. Error - ${e.error.message}`);
    }
  }

  applyFilter() {
    const textFilter = (this.textFilter || '').trim().toLowerCase();
    const showActiveOnly = this.showActiveOnly;
    console.log(textFilter, showActiveOnly);

    let result = this.allItems;

    if (textFilter.length > 0) {
      result = result.filter(c => {
        if (c.brandName.toLowerCase().includes(textFilter)) { return true; }
        if (c.text.toLowerCase().includes(textFilter)) { return true; }

        return false;
      });

     /* if (result.length === 0) {
        result = this.allItems;
        this.showToast('Filtering', `No results for the filter: ${textFilter}`);
      }*/
    }

    if (showActiveOnly) {
      result = result.filter(c => c.active);
    }

    this.filteredItems = result;
  }
}
